export default __webpack_public_path__ + "static/media/grinding.938c7c4c.webp";